// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  firebase: {
    projectId: 'smart-notification-5b71c',
    appId: '1:5388431872:web:fc1db379cbd0b4643edee5',
    storageBucket: 'smart-notification-5b71c.appspot.com',
    apiKey: 'AIzaSyCWOpFfbdvqIFQllqcAAtrbKsQQIm3Z4y4',
    authDomain: 'smart-notification-5b71c.firebaseapp.com',
    messagingSenderId: '5388431872',
    measurementId: 'G-5EKV3GL3MR',
  },
  production: false
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
